/**
 * @file
 * Close Radix/Bootstrap markup status alerts without loading full Bootstrap JS.
 */
(function (Drupal, once) {
  Drupal.behaviors.globalDismissibleAlerts = {
    attach(context) {
      once(
        'global-dismiss-alert',
        '.alert-dismissible .btn-close[data-bs-dismiss="alert"]',
        context,
      ).forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const alert = button.closest('.alert');
          if (!alert) {
            return;
          }
          const region = alert.closest('[role="region"]');
          alert.remove();
          if (region && !region.querySelector('.alert')) {
            region.remove();
          }
        });
      });
    },
  };
})(Drupal, once);
